<template>
  <div class="sidebar-title-wrapper" data-testing="sidebar-wrapper">
    <h3 class="sidebar-title" :style="{ fontSize: `${fontSize}px` }">{{
      title
    }}</h3>
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  title: {
    required: true,
    type: String
  },
  fontSize: {
    required: false,
    type: Number,
    default: 14
  }
});
</script>
<style lang="scss" scoped>
.sidebar-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.sidebar-title {
  font-weight: bold;
  margin-bottom: 0;
  padding-bottom: 0;
}
</style>
